export const getLots = (state) => state.lots
